import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionService } from '../../../shared/services/session.service';
import { PaymentService } from '../../../shared/services/payment.service';
import { UserDto } from '../../../model/user/user-dto';
import { MaskUtil } from '../../../shared/utils/star-masking-util';
import { TextService } from '../../../shared/services/text.service';
import { SdkInitText } from '../../../model/user/sdk-init-text';

@Component({
  selector: 'pa-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.scss']
})
export class SmsComponent implements OnInit {

  user: UserDto;
  phoneNumber: string;

  deadline: number;

  routeButtonStatus: boolean;
  errorMessage: string;
  approvalTimeoutDuration: string;
  approvalCheckFrequency: string;
  timerHasEnded: boolean = false;
  timeout: any;
  textService: TextService;
  trackingId: string;
  sdkInitTexts: Array<SdkInitText>;

  constructor(private router: Router, private route: ActivatedRoute, private sessionService: SessionService, private paymentService: PaymentService,
              private changeDetectionRef: ChangeDetectorRef, textService: TextService) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
    });
    this.queryDcbPaymentStatus();
    this.getUser();
  }

  getUser() {
    this.sessionService.getInitUser(this.trackingId).subscribe(response => {
      this.user = response;
      this.sdkInitTexts = response.sdkInitTexts;
      this.phoneNumber = MaskUtil.MaskingConfiguration(response.msisdn, 3, 6);
      this.approvalTimeoutDuration = response.approvalTimeoutDuration;
      this.approvalCheckFrequency = response.approvalCheckFrequency;
      this.updateTimer();
    }, error => {
      this.router.navigate(['/result/error', this.trackingId]);
    });
  }

  queryDcbPaymentStatus() {
    let responseCode: string;
    let displayText: string;
    this.routeButtonStatus = false;
    this.paymentService.queryDcbPaymentStatus(this.trackingId).subscribe(
      response => {
        responseCode = response.params.responseCode;
        displayText = response.params.displayText;
        if (responseCode == '0') {

          response.params.responseCode = null;
          response.params.displayText = null;
          this.router.navigate(['/result/payment', this.trackingId], {queryParams: response.params});

        } else if (responseCode == "2315" && !this.timerHasEnded) {
          this.timeout = setTimeout(() => {
            this.queryDcbPaymentStatus();
          }, parseInt(this.approvalCheckFrequency));
        } else {
          this.stop();
        }
      },
      error => {
        this.stop();
        this.errorMessage = error.message;
        this.routeButtonStatus = true;
      }
    );
  }

  makePayment() {
    this.paymentService.makePayment(this.user.payment, this.trackingId).subscribe(response => {
      this.updateTimer();
      this.queryDcbPaymentStatus();
    }, (error) => {
      this.router.navigate(['/result/error', this.trackingId]);
    });
  }

  updateTimer(): void {
    this.deadline = Date.now() + 1000 * 60 * (parseInt(this.approvalTimeoutDuration) / 60);
    this.timerHasEnded = false;
  }

  stop() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.errorMessage = 'Size ayrılan sürede işleminizi tamamlamadınız lütfen tekrar deneyin.';
    this.timerHasEnded = true;
    this.routeButtonStatus = false;
    this.changeDetectionRef.detectChanges();
  }

}
